import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/HomeClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/components/SharedLayout.tsx");
